import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
import infra from './routes/infra'
// import uiElements from './routes/ui-elements/index'
import pages from './routes/pages'
// import chartsMaps from './routes/charts-maps'
// import formsTable from './routes/forms-tables'
import others from './routes/others'
import tools from './routes/tools'
import devRoutes from './routes/dev'
// import ems from './routes/ems'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  // scrollBehavior() {
  //   return { x: 0, y: 0 }
  // },
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if(savedPosition) {
          console.log('saved postion',savedPosition, from)
          //window.addEventListener('scroll', savedPosition);
          localStorage.setItem('lastPosition', JSON.stringify(savedPosition))
          localStorage.setItem('from', JSON.stringify(from))
          resolve(savedPosition)
          
        } else {
          const savedPosition = { x: 0, y: 0 }
          localStorage.setItem('lastPosition', savedPosition)
          resolve(savedPosition)
        }
      }, 500)
    })
  },
  routes: [
    { path: '/', redirect: { name: 'dashboard-main' } },
    ...apps,
    ...dashboard,
    ...pages,
    ...infra,
    ...tools,
    ...(process.env.NODE_ENV !== 'production' ? devRoutes : []),
    // ...ems,
    //  ...chartsMaps,
    // ...formsTable,
    // ...uiElements,
    ...others,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = isUserLoggedIn()
  const lastPageUrl = window.sessionStorage.getItem('lastPage');

  // ==========================================================================
  // PRIMARY GATE — must run BEFORE `canNavigate(to)`, not nested inside its
  // "false" branch like before. `initialAbility` (`src/libs/acl/config.js`,
  // used by `getAbilities()` in `src/libs/acl/ability.js` whenever there's
  // no cached `userData`) intentionally grants a handful of resources
  // (`task_management`, `attendance_my_dashboard`, `jobs`,
  // `report`, `interview`, etc.) by default so a freshly-issued session
  // isn't locked out before the backend's real abilities load. That means
  // `canNavigate(to)` can return TRUE for plenty of authenticated routes
  // even when NOBODY is logged in. On top of that, the CASL `ability`
  // singleton is a module-level object that is only ever updated on login —
  // a user who logs out keeps their old (possibly very broad) abilities in
  // memory unless something explicitly resets it (see the fix for that in
  // `UserDropdown.vue#logout()`). Either way, `canNavigate` alone is NOT a
  // reliable signal for "is there a valid session at all", so this used to
  // let navigation fall through to `next()` below and mount the
  // authenticated layout (navbar/sidebar, including `UserDropdown`) with a
  // null `userData` — crashing on `userData.first_name`/`userData.roles[0]`
  // before any component-level redirect-to-login safety net had a chance to
  // run. `to.meta.layout === 'full'` marks every route that's explicitly
  // meant to be reachable while logged out (login, error/not-authorized/
  // under-maintenance/coming-soon, the public documentation link) — those
  // never render the authenticated layout, so they're exempt here and still
  // go through the normal `canNavigate` check below.
  // ==========================================================================
  if (!isLoggedIn && to.meta.layout !== 'full') {
    if (lastPageUrl !== '/login') {
      window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
    }
    return next({ name: 'auth-login' })
  }

  if (!canNavigate(to)) {
    // Reachable now only when genuinely logged in but lacking the ability
    // for this specific route (or for one of the `layout: 'full'` pages
    // above while logged out, same fallback as before).
    if (!isLoggedIn && lastPageUrl !== '/login') {
      return next({ name: 'auth-login' })
    }
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in and this route is explicitly for logged-out users
  // (e.g. don't let an already-logged-in user sit on /login).
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    return next(getHomeRouteForLoggedInUser(userData ? userData.roles[0] : null))
  }

  window.sessionStorage.setItem('scrollPosition', window.pageYOffset)
  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
  const scrollPosition = +window.sessionStorage.getItem('scrollPosition')
  if (scrollPosition) {
    window.scrollTo(0, scrollPosition)
    window.sessionStorage.removeItem('scrollPosition')
  }
})

export default router